import {Injectable} from "@angular/core";

declare let gtag: any;

@Injectable()
export class GoogleAnalyticsService {

  public emitEvent(eventCategory: string,
                   eventAction: string,
                   eventLabel: string = null,
                   eventValue: number = null) {
    gtag('event', 'eventview', {
      eventCategory: eventCategory,
      eventLabel: eventLabel,
      eventAction: eventAction,
      eventValue: eventValue
    });
  }

 public trackPage(pageName: string){
    gtag('event', 'pageview', pageName);
 }

}


// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/common/service/google-analytics.service.ts